import { useEffect, useState } from 'react';
import { api } from '../api';
import { setSignedIn as setVisitedSignedIn } from '../state/visited';
import { IconFacebook, LogoMark } from './icons';
import { SubscribeBox } from './SubscribeBox';

export function Brand() {
  return (
    <a className="brand" href="/" aria-label="The Yard Sale Map, home">
      <LogoMark />
      <span>The Yard Sale Map</span>
    </a>
  );
}

export function TopBar() {
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    api.get<{ user: unknown }>('/me').then((r) => {
      setSignedIn(r.user !== null);
      setVisitedSignedIn(r.user !== null);
    });
  }, []);
  return (
    <header className="topbar">
      <Brand />
      <span className="spacer" />
      <nav aria-label="Site">
        <a href="/how-it-works">How it works</a>
        <a href="/about">About</a>
        <a href="/account">{signedIn ? 'My account' : 'Sign in'}</a>
      </nav>
      <a className="btn primary pill" href="/submit">
        List a sale
      </a>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="footer">
      <SubscribeBox />
      <div className="inner">
        <a href="/how-it-works">How it works</a>
        <a href="/about">About</a>
        <a href="/advertise">Advertise</a>
        <a href="/add-place">Add a shop</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
        <a
          href="https://www.facebook.com/theyardsalemap"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-facebook"
          aria-label="The Yard Sale Map on Facebook"
          onClick={() => {
            // No GA/gtag wired up yet (see public/index.html) -- this fires once it is, no
            // measurement ID invented here.
            (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag?.('event', 'facebook_click', {
              event_category: 'social',
              event_label: 'footer_facebook',
            });
          }}
        >
          <IconFacebook />
          <span>Facebook</span>
        </a>
        <span className="spacer" />
        <span>Free to browse. Free to list.</span>
      </div>
    </footer>
  );
}
